import { Stack } from "@similarweb/ui-components/foundations";

import { AdsAlertsFeed } from "../ads-alerts/AdsAlertsFeed";
import { AdsAlertsFilters } from "../ads-alerts/filters/AdsAlertsFilters";
import { AlertsErrorBoundary } from "../AlertsErrorBoundary";
import type { AlertViewMode } from "../tabs/viewModeConfig";

type AdsPanelProps = {
    viewMode: AlertViewMode;
};

export const AdsPanel = ({ viewMode }: AdsPanelProps) => (
    <Stack
        gap="32px"
        flexGrow={1}
    >
        <AdsAlertsFilters />
        <AlertsErrorBoundary
            alertType="ads"
            viewMode={viewMode}
        >
            {viewMode === "feed" ? <AdsAlertsFeed /> : null}
        </AlertsErrorBoundary>
    </Stack>
);
